
import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {filter} from 'rxjs/operators';
import {ChangeDetectorRef} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {

  title = 'Reports';
  previousUrl!: string;
  constructor(private router:Router, private titleService: Title, private cdr: ChangeDetectorRef) {
    router.events.pipe(filter(event =>event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.previousUrl = event.url;
      this.cdr.detectChanges();
    });
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
  }


  onReportClick(reportCode: string, reportName: string)
  {
    sessionStorage.setItem('reportCode', reportCode );
    sessionStorage.setItem('reportName', reportName );

    const reportType = 'Adhoc Reports';

    this.router.navigate(['/reportCreiteria'], {queryParams:{
      reportType:reportType,
      previousUrl:this.previousUrl

    }});

  }

}
